/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  CloseAllIsolatedPositionsStatus201,
  CloseAllIsolatedPositionsStatus400,
  CloseAllIsolatedPositionsStatus401,
  CloseAllIsolatedPositionsStatus404,
  CloseAllIsolatedPositionsStatus500,
} from '../types/CloseAllIsolatedPositions'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { closeAllIsolatedPositions } from '../clients/closeAllIsolatedPositions'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const closeAllIsolatedPositionsMutationKey = () =>
  [{ url: '/v1/positions/close/all' }] as const

export function closeAllIsolatedPositionsMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = closeAllIsolatedPositionsMutationKey()
  return mutationOptions<
    CloseAllIsolatedPositionsStatus201,
    ResponseErrorConfig<
      | CloseAllIsolatedPositionsStatus400
      | CloseAllIsolatedPositionsStatus401
      | CloseAllIsolatedPositionsStatus404
      | CloseAllIsolatedPositionsStatus500
    >,
    undefined,
    TContext
  >({
    mutationKey,
    mutationFn: async (_) => {
      return closeAllIsolatedPositions({ ...config, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Close all open isolated positions in one request
 * {@link /v1/positions/close/all}
 */
export function useCloseAllIsolatedPositions<TContext>(
  options: {
    mutation?: UseMutationOptions<
      CloseAllIsolatedPositionsStatus201,
      ResponseErrorConfig<
        | CloseAllIsolatedPositionsStatus400
        | CloseAllIsolatedPositionsStatus401
        | CloseAllIsolatedPositionsStatus404
        | CloseAllIsolatedPositionsStatus500
      >,
      undefined,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? closeAllIsolatedPositionsMutationKey()

  const baseOptions = closeAllIsolatedPositionsMutationOptions(config) as UseMutationOptions<
    CloseAllIsolatedPositionsStatus201,
    ResponseErrorConfig<
      | CloseAllIsolatedPositionsStatus400
      | CloseAllIsolatedPositionsStatus401
      | CloseAllIsolatedPositionsStatus404
      | CloseAllIsolatedPositionsStatus500
    >,
    undefined,
    TContext
  >

  return useMutation<
    CloseAllIsolatedPositionsStatus201,
    ResponseErrorConfig<
      | CloseAllIsolatedPositionsStatus400
      | CloseAllIsolatedPositionsStatus401
      | CloseAllIsolatedPositionsStatus404
      | CloseAllIsolatedPositionsStatus500
    >,
    undefined,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    CloseAllIsolatedPositionsStatus201,
    ResponseErrorConfig<
      | CloseAllIsolatedPositionsStatus400
      | CloseAllIsolatedPositionsStatus401
      | CloseAllIsolatedPositionsStatus404
      | CloseAllIsolatedPositionsStatus500
    >,
    undefined,
    TContext
  >
}
